module.exports = __webpack_public_path__ + "img/w_outdoor.fa693eff.svg";